import React, { useState } from "react";
import MainComponent from "../components/MainComponent";
import ScriptBox from "../components/ScriptBox";
import ScriptResponse from "../components/ScriptResponse";
import Objections from "../components/Objections";
import Modal from "../components/Modal";

const PageOne = () => {
  const [mainLayout, setMainLayout] = useState(true);
  const [objectionLayout, setObjectionLayout] = useState(false);
  const [secondSec, setSecondSec] = useState(false);
  const [scriptResponse, setScriptResponse] = useState(false);
  const [scriptResponseData, setScriptResponseData] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(true);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const mainHandler = () => {
    setMainLayout(false);
    setSecondSec(true);
  };

  const objectionHandler = () => {
    setMainLayout(false);
    setObjectionLayout(true);
  };

  const scriptResponseHandler = () => {
    setSecondSec(false);
    setScriptResponse(true);
  };

  const updateResponse = (data) => {
    setScriptResponseData(data);
  };

  const backToMain = () => {
    setSecondSec(false);
    setScriptResponse(false);
    setObjectionLayout(false);
    setMainLayout(true);
  };
  return (
    <>
      {/*<button className="btn btn-main" onClick={openModal}>*/}
      {/*  Lounch Application*/}
      {/*</button>*/}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <React.Fragment>
          {mainLayout && (
            <MainComponent
              layerHandler={mainHandler}
              objectionLayer={objectionHandler}
            />
          )}
          {secondSec && (
            <ScriptBox
              responseHandler={scriptResponseHandler}
              updateResponse={updateResponse}
              backhandler={backToMain}
            />
          )}
          {scriptResponse && (
            <ScriptResponse
              finalResponse={scriptResponseData}
              backhandler={backToMain}
            />
          )}
          {objectionLayout && <Objections backhandler={backToMain} />}
        </React.Fragment>
      </Modal>
    </>
  );
};

export default PageOne;
